<template>
  <div>
    <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
      <v-card :color="changeColor" outlined class="mb-3" :loading="loadingSubmit">
        <v-card-title> {{ veiculo.modelo.marca.nome }} - {{ veiculo.modelo.nome }} </v-card-title>
        <v-card-subtitle>{{ veiculo.placa }} - {{ veiculo.ano }}</v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col class="py-0" md="6" cols="12">
              <v-autocomplete
                :error-messages="errors.turno_id"
                :items="turnos"
                :rules="rules.turno_id"
                clearable
                dense
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                label="Turno"
                outlined
                persistent-hint
                placeholder="Selecione o turno"
                v-model="formData.turno_id"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" md="6" cols="12">
              <v-autocomplete
                :error-messages="errors.rota_id"
                :items="rotas"
                :rules="rules.rota_id"
                clearable
                dense
                hide-no-data
                hide-selected
                item-text="nome"
                item-value="id"
                label="Rota"
                outlined
                persistent-hint
                placeholder="Selecione a rota"
                v-model="formData.rota_id"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="py-0" cols="12">
              <v-autocomplete
                :error-messages="errors.motorista_id"
                :items="motoristas"
                :rules="rules.motorista_id"
                clearable
                dense
                hide-no-data
                hide-selected
                item-text="motorista.pessoa.nome"
                item-value="motorista.id"
                label="Motorista"
                outlined
                persistent-hint
                placeholder="Selecione o motorista"
                v-model="formData.motorista_id"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-radio-group
            v-model="formData.presente"
            row
            :rules="rules.presente"
            :error-messages="errors.presente"
          >
            <template v-slot:label>
              <div>Presente?</div>
            </template>
            <v-radio
              label="Sim"
              :value="true"
            ></v-radio>
            <v-radio
              label="Não"
              :value="false"
            ></v-radio>
          </v-radio-group>
          <v-expansion-panels flat focusable>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Observação
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-5 pb-0 mb-0">
                <v-textarea
                  dense
                  outlined
                  placeholder="Digite sua observação caso seja necessário."
                  v-model="formData.observacao"
                  class="pa-0" full-width
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions class="px-4 py-3">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!valid"
            :loading="loadingSubmit"
            color="green"
            dark
            depressed
            type="submit"
          >
            <v-icon left small>mdi-send</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { required, requiredBool } from '@/services/util/validate';
import toastMessage from '@/services/util/alertService';
import frequenciaHttp from '@/services/http/resources/frota/frequenciaHttp';

export default {
  name: 'ListVeiculo',
  props: {
    dados: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: true,
    formData: {
      id: '',
      competencia_id: '',
      dia_id: '',
      veiculo_id: '',
      motorista_id: '',
      turno_id: '',
      rota_id: '',
      orgao_id: '',
      presente: null,
      observacao: '',
    },
    formDataDefault: {
      id: '',
      competencia_id: '',
      dia_id: '',
      veiculo_id: '',
      motorista_id: '',
      turno_id: '',
      rota_id: '',
      orgao_id: '',
      presente: null,
      observacao: '',
    },
    rules: {
      veiculo_id: [required],
      motorista_id: [required],
      turno_id: [required],
      presente: [requiredBool],
    },
    errors: {
      veiculo_id: [],
      motorista_id: [],
      turno_id: [],
      rota_id: [],
      presente: [],
      observacao: [],
    },
    loadingSubmit: false,
    isloadingVeiculo: false,
    itemsAutoCompleteVeiculo: [],
    searchAutoCompleteVeiculo: '',
  }),
  mounted() {
    this.getFormData();
  },
  computed: {
    turnos() {
      return this.dados.turnos;
    },
    veiculo() {
      return this.dados.veiculo;
    },
    frequencia() {
      return this.veiculo.frequencia;
    },
    motoristas() {
      return this.veiculo.motoristas;
    },
    rotas() {
      return this.veiculo.rotas;
    },
    isChecked() {
      return this.formData.id;
    },
    changeColor() {
      if (this.formData.id) {
        return this.formData.presente ? 'green lighten-5' : 'red lighten-5';
      }
      return null;
    },
  },
  methods: {
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
        this.loadingSubmit = false;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loadingSubmit = true;
        frequenciaHttp
          .store(this.formData)
          .then(({ data: { data } }) => {
            toastMessage.successSave('Frequencia Salva com sucesso');
            this.updateFormdata(data);
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave();
            }
          })
          .finally(() => {
            this.loadingSubmit = false;
          });
      }
    },
    getFormData() {
      if (this.frequencia) {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.frequencia[key];
        });
      } else {
        const listNoUpdate = ['motorista_id', 'turno_id', 'presente', 'rota_id', 'observacao'];
        Object.entries(this.formDataDefault).forEach(([key]) => {
          if (key === 'id') {
            this.formData[key] = '';
          } else if (key === 'veiculo_id') {
            this.formData[key] = this.veiculo.id;
          } else if (!listNoUpdate.includes(key)) {
            this.formData[key] = this.dados.formData[key];
          }
        });
      }
    },
    updateFormdata(data) {
      Object.entries(this.formDataDefault).forEach(([key]) => {
        this.formData[key] = data[key];
      });
    },
  },
  watch: {
    'formData.veiculo_id': function () {
      this.errors.veiculo_id = [];
    },
    'formData.motorista_id': function () {
      this.errors.motorista_id = [];
    },
    'formData.turno_id': function () {
      this.errors.turno_id = [];
    },
    'formData.presente': function () {
      this.errors.presente = [];
    },
  },
};
</script>
